// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD5osWA36auJfqrRoewK_0NQrcVks3FziY",
  authDomain: "dogge-chatbot.firebaseapp.com",
  databaseURL:
    "https://dogge-chatbot-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "dogge-chatbot",
  storageBucket: "dogge-chatbot.appspot.com",
  messagingSenderId: "691860608034",
  appId: "1:691860608034:web:4979552df507cd08d8a67b",
  measurementId: "G-NN2MKCDE4S",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { firebaseConfig };
